import Button from '@doordash/component-button'
import { Text, StackChildren } from '@doordash/design-language'
import { FeatureFlag } from '@doordash/lib-feature-flags'
import * as moment from 'moment-timezone'
import * as React from 'react'
import { CANADA_HELP_URL } from '../../../constants'

import t from './strings'
import { Link } from './styles'

type ScheduleOrientationDetailsProps = {
  orientation: {
    startTime: string
    address: string
  }
  country: string
  uniqueLink: string
  timezone: string
  clearOrientation: any
}
const formatAppointmentTime = (appointmentTime, timezone) =>
  moment(appointmentTime)
    .tz(timezone)
    .format('MMM Do [at] h:mm A')

const ScheduleOrientationDetails: React.SFC<ScheduleOrientationDetailsProps> = props => (
  <StackChildren>
    <Text styles={Text.Styles.Bold24}>{t.h1()}</Text>
    <Text lineHeight={Text.LineHeights.Medium} weight={Text.Weights.Bold}>
      {formatAppointmentTime(props.orientation.startTime, props.timezone)}
    </Text>
    <Text lineHeight={Text.LineHeights.Medium}>
      {props.orientation.address}
    </Text>
    <Button
      type={Button.Types.Tertiary}
      onClick={() => props.clearOrientation(props.uniqueLink)}
    >
      {t.reschedule()}
    </Button>
    <br />
    <Text styles={Text.Styles.Caps16}>{t.bgTitle()}</Text>
    <StackChildren>
      <FeatureFlag
        on={() => <Text>• {t.bgStepOne()}</Text>}
        off={() => (
          <Text>
            • {props.country === 'AU' ? t.bgStepOne() : t.bgStepTwo()}
          </Text>
        )}
        flagName="canadaBgcOutOfBand"
      />
      <Text>• {t.bgStepThree()}</Text>
      <Text>• {t.bgStepFour()}</Text>
      <Text>• {t.bgStepFive()}</Text>
    </StackChildren>
    <br />
    <Text styles={Text.Styles.Caps16}>{t.whatToBring()}</Text>
    <StackChildren>
      <Text>• {t.whatToBringOne()}</Text>
      {(() => {
        switch (props.country) {
          case 'AU':
            return (
              <Text>
                • {t.ausWhatToBringTwo()}
                <Link
                  // tslint:disable-next-line:max-line-length
                  href="https://www.nationalcrimecheck.com.au/files/695_id.pdf"
                  target="_blank"
                >
                  {t.ausIdLink()}
                </Link>
              </Text>
            )
          case 'PR':
            return <Text>• {t.prWhatToBringTwo()}</Text>
          default:
            return (
              <Text>
                • {t.whatToBringTwo()}
                <FeatureFlag
                  on={() => (
                    <span>
                      {` ${t.or()} `}
                      <a href={CANADA_HELP_URL}>{t.whatToBringTwoAlt()}</a>
                    </span>
                  )}
                  flagName="canadaBgcOutOfBand"
                />
              </Text>
            )
        }
      })()}
      <Text>• {t.whatToBringThree()}</Text>
    </StackChildren>
    <br />
  </StackChildren>
)

export default ScheduleOrientationDetails
